import { useMsal } from "@azure/msal-react";
import * as React from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { CONTEXTCLAIMTYPE, useUser } from "../utils/AccountStore";
import CommunicationLayout from "../components/CommunicationLayout";
import {
    CreateQuestionnaire,
    EntityTypeViewModel,
    GetEntity,
    GetEntityType,
    ListEntities,
    QuestionnaireTypeViewModel,
    QuestionnaireViewModel,
} from "../utils/ServiceManagerAPI";
import SkeletonWrapper from "../components/SkeltonWrapper";
import { loginRequest } from "../authConfig";
import Disposal from "./Disposal";
import EntitiesList from "../components/EntitiesList";
import Entity from "./Entity";
import { useEntityAction } from "../components/EntityActionContext";
import { useEntities } from "../components/EntitiesContext";

const Home = () => {
    const location = useLocation();
    const [loading, setLoading] = React.useState(true);
    const [entityLoading, setEntityLoading] = React.useState(true);
    const { instance } = useMsal();
    const { user, setUser } = useUser();

    const [entityType, setEntityType] = React.useState<EntityTypeViewModel | null>(null);
    const [entityCreationForms, setEntityCreationForms] = React.useState<QuestionnaireTypeViewModel[]>([]);
    const [entityDataForms, setEntityDataForms] = React.useState<QuestionnaireTypeViewModel[]>([]);

    const [entities, setEntities] = React.useState<QuestionnaireViewModel[]>([]);
    const [selectedEntity, setSelectedEntity] = React.useState<QuestionnaireViewModel | null>(null);

    const [currentEntity, setCurrentEntity] = React.useState<any>(null);
    const [entityData, setEntityData] = React.useState<any[]>([]);

    const navigate = useNavigate();
    const { setEntity } = useEntityAction();
    const { setEntities: setEntitiesContext } = useEntities();

    React.useEffect(() => {
        if (user.isAuthenticated) {
            let context = user.claims.filter((c) => c.type === CONTEXTCLAIMTYPE)[0]?.value;
            if (context) {
                // Context logic if needed
            }
            setEntityLoading(true);
            refreshData();
        }
    }, [user, location]);

    const refreshData = () => {
        Promise.all([
            GetEntityType(EntityTypeID).then((res) => {
                setEntityType(res.value);
                setEntityCreationForms(res.value?.questionnaireTypes?.filter((qt) => qt.subjectType === 4) || []);
                setEntityDataForms(res.value?.questionnaireTypes?.filter((qt) => qt.subjectType === 5) || []);
            }),
            ListEntities(EntityTypeID).then((res) => {
                setEntities(res.value);
                setEntitiesContext(res.value);
                if (location.pathname.startsWith("/entities")) {
                    let entity = res.value.filter((e) => e.id === location.pathname.split("/")[2])[0];
                    if (entity) {
                        setSelectedEntity(entity);
                        return;
                    }
                } else {
                    if (selectedEntity?.id) {
                        return GetEntity(selectedEntity?.id).then((res) => {
                            setCurrentEntity(res.value);
                            setEntityData(res.value.data);
                        });
                    } else {
                        setSelectedEntity(null);
                        setCurrentEntity(null);
                        setEntityData([]);
                    }
                }
            }),
        ]).then(() => {
            setLoading(false);
            setEntityLoading(false);
        });
    };

    React.useEffect(() => {
        if (selectedEntity) {
            setEntity(selectedEntity);
            setEntityLoading(true);
            GetEntity(selectedEntity.id).then((res) => {
                setCurrentEntity(res.value);
                setEntityData(res.value.data);
            });
        }
    }, [selectedEntity]);

    const createEntity = (organizationID: string, questionnaireTypeID: string) => {
        if (entityType) {
            CreateQuestionnaire({ name: entityType.name, organizationID: organizationID, questionnaireTypeID: questionnaireTypeID }).then((res) => {
                navigate(`/entities/${res}/questionnaires/${res}`);
            });
        }
    };

    const msalInstance = useMsal();

    React.useEffect(() => {
        if (user?.isAuthenticated) {
            console.log(user.getClaim(CONTEXTCLAIMTYPE), DefaultOrganization);
            if (user.getClaim(CONTEXTCLAIMTYPE) !== DefaultOrganization) {
                msalInstance.instance.loginRedirect({
                    ...loginRequest,
                    prompt: "login",
                    extraQueryParameters: {
                        context: DefaultOrganization,
                        ui_locales: `switchTo:true`,
                    },
                });
            }
        }
    }, [user]);

    return (
        <div className="w-screen">
            {user && (
                <CommunicationLayout
                    list={
                        <EntitiesList
                            loading={loading}
                            entityCreationForms={entityCreationForms}
                            createEntity={createEntity}
                            entities={entities}
                            selectedEntity={selectedEntity}
                            setSelectedEntity={setSelectedEntity}
                        />
                    }
                    content={
                        <Routes>
                            <Route path="/entities/:entityId/*" element={<Entity onUpdate={() => refreshData()} />} />
                            <Route path="/disposal/" element={<Disposal />} />
                        </Routes>
                    }
                />
            )}
        </div>
    );
};

export default Home;
